<template>
    <div>
        <template >
            <z-title title="会员基本信息" ref="title"></z-title>
            <el-card class="content1" ref="search">
                <div class="flex-n fac fjb ">

                <el-button type="primary" class="ele-btn1 mr-10" @click="addMember">新增会员</el-button>
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        placeholder="输入会员卡号"
                        maxlength="8"
                        clearable
                        title="输入要搜索的会员卡号"
                        prefix-icon="el-icon-search"
                        v-model="memberNo">
                </el-input>
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        type="number"
                        clearable
                        placeholder="输入会员电话号码"
                        title="输入会员电话号码"
                        prefix-icon="el-icon-search"
                        maxlength="11"
                        v-model="memberPhone">
                </el-input>
                <el-input
                        size="medium"
                        class="ele-input mr-10"
                        placeholder="输入会员姓名"
                        maxlength="8"
                        clearable
                        title="输入要搜索的会员姓名"
                        prefix-icon="el-icon-search"
                        v-model="memberName">
                </el-input>
                <div class="textnowrap">状态：</div>
                <card-state-code class="mr-10" clearable size="medium" v-model="cardState"
                                 placeholder="全部"></card-state-code>
                <div class="textnowrap">适用门店：</div>
                <store-list class="mr-10"  clearable size="medium" v-model="storeId" placeholder="全部门店"></store-list>
                <el-button type="primary" class="ele-btn2" @click="searchMember">查询</el-button>
                </div>

            </el-card>
            <el-card class="mt-10">
                <el-table
                        v-loading="loading"
                        :height="height+'px'"
                        highlight-current-row
                        element-loading-text="列表刷新中"
                        header-cell-class-name="headerrow"
                        cell-class-name="cellclass"
                        :data="dataList"
                        style="width: 100%">
                    <el-table-column
                            fixed
                            align="center"
                            prop="memberNo"
                            label="会员卡号"
                            width="140">
                    </el-table-column>
                    <el-table-column
                            prop="memberName"
                            label="姓 名"
                            width="130"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="memberPhone"
                            label="手机号码"
                            width="130"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="cardTypeName"
                            label="类 别"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="memberCardName"
                            label="类别名称"
                            width="180"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            label="规 则"
                            width="220"
                            align="center">
                        <template slot-scope="scope">
                            <template v-if="scope.row.cardType=='01'">
                                {{scope.row.cardRule}}
                            </template>
                            <template v-else>
                                {{scope.row.discount}}折
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="cardDiscount"
                            label="折 扣"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="totalCharge"
                            label="充值总额"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="totalReceive"
                            label="实际到账"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="totalConsume"
                            label="消费总额"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="cardBalance"
                            label="卡内余额"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="cardStateName"
                            label="状 态"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="suitStoresContent"
                            label="适用门店"
                            width="160"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="160"
                            align="center">
                        <template slot-scope="scope">
                            <div style="margin: 5px 0">
                                <el-button type="primary" class="ele-btn-small" v-if="scope.row.cardType=='01'&&scope.row.cardState=='01'" @click="handleClick(scope.row.id,0)">
                                    消费
                                </el-button>
                                <el-button type="primary" class="ele-btn-small" @click="handleClick(scope.row.id,1)">修改
                                </el-button>
                                <el-button type="primary" class="ele-btn-small" v-if="scope.row.cardType=='01'&&scope.row.cardState=='01'"  @click="handleClick(scope.row.id,2)">充值
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                            @currentChange="handleCurrentChange"></pagination>
            </el-card>

            <!--新增编辑会员-->
            <el-dialog :visible.sync="showdialog" v-if="showdialog"  class="doedit" width="760px" :close-on-click-modal="false">
                <div slot="title">
                    <z-title :title="editstate+'会员'"></z-title>
                </div>
                <div class="rulefrom2">

                    <!--订单确认收款-->
                    <el-form :model="dataForm" :rules="rules" ref="ruleForm" class=" mt-10">
                        <el-form-item label="会员卡号" :show-message="false" prop="memberNo" label-width="80px">
                            <el-input placeholder="请输入会员卡号" class="w-220" v-model="dataForm.memberNo"></el-input>
                        </el-form-item>
                        <el-form-item label="会员姓名" :show-message="false" prop="memberName" label-width="80px">
                            <el-input placeholder="请输入会员姓名" class="w-220" v-model="dataForm.memberName"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码" :inline-message="true"  prop="memberPhone" label-width="80px">
                            <el-input placeholder="请输入手机号码" class="w-220" v-model="dataForm.memberPhone"></el-input>
                        </el-form-item>
                        <div class="flex-n fac">
                            <el-form-item label="会员类别" :show-message="false" prop="memberCardId" label-width="80px">
                                <div class="flex-n fac">
                                    <member-type-list class="w-220" clearable size="medium"
                                                      v-model="dataForm.memberCardId"
                                                      @change="changeMemberlist" placeholder="请选择"></member-type-list>
                                    <div class="ml-20" v-if="dataForm.cardType=='02'">{{dataForm.cardDiscount||10}}折
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="充值金额" v-if="dataForm.cardType=='01'" :show-message="false"
                                          prop="totalCharge" label-width="80px">
                                <el-input placeholder="请输入充值金额" class="w-220" v-model="dataForm.totalCharge"></el-input>
                            </el-form-item>
                        </div>
                        <el-form-item label="适用门店" :show-message="false" prop="suitStores" label-width="80px">
                            <store-drop  class="w-220" ref="storelist"   size="medium" v-model="dataForm.suitStores"
                                         @change="getStores"       placeholder="请选择"></store-drop>
                        </el-form-item>
                        <!--修改时携带-->
                        <el-form-item v-if="editstate=='编辑'" label="会员状态" :show-message="false" prop="cardState"
                                      label-width="80px">
                            <card-state-code class="w-220" clearable size="medium" v-model="dataForm.cardState"
                                             placeholder="请选择"></card-state-code>
                        </el-form-item>
                        <el-form-item label="备 注" prop="remark" label-width="80px">
                            <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                                      maxlength="512"></el-input>
                        </el-form-item>
                        <el-form-item class="mt-10 flex-n fje">
                            <el-button type="primary" @click="submitForm('ruleForm')">保 存</el-button>
                            <el-button @click="showdialog=false">取 消</el-button>
                        </el-form-item>
                    </el-form>
                </div>

            </el-dialog>

            <!--消费-->
            <el-dialog :visible.sync="showPay" v-if="showPay" class="doedit" width="760px" :close-on-click-modal="false">
                <div slot="title">
                    <z-title title="会员卡消费"></z-title>
                </div>
                <div class="rulefrom2">
                    <el-form :model="dataForm" :rules="rules" ref="payForm" class=" mt-10">
                        <el-form-item label="会员卡号" :show-message="false" prop="memberNo" label-width="80px">
                            <el-input placeholder="请输入会员卡号" disabled class="w-220"
                                      v-model="dataForm.memberNo"></el-input>
                        </el-form-item>
                        <el-form-item label="会员姓名" :show-message="false" prop="memberName" label-width="80px">
                            <el-input placeholder="请输入会员姓名" disabled class="w-220"
                                      v-model="dataForm.memberName"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码" prop="memberPhone" label-width="80px">
                            <el-input placeholder="请输入手机号码" disabled class="w-220"
                                      v-model="dataForm.memberPhone"></el-input>
                        </el-form-item>
                        <el-form-item label="卡内余额" :show-message="false" prop="cardBalance" label-width="80px">
                            <el-input placeholder="请输入卡内余额" disabled class="w-220"
                                      v-model="dataForm.cardBalance"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码" prop="downPayment" label-width="80px">
                            <div class="flex-n fac">
                                <el-input placeholder="输入验证码" class="w-220 mr-10" v-model="dataForm.qrcode">
                                </el-input>
                                <el-button type="primary" v-if="sendcodestate!=2" class="ele-btn-small" @click="sendCode(dataForm.memberPhone)" >{{sendcodestate=='0'?'发送验证码':'重新获取'}}</el-button>
                                <el-button class="ele-btn-small" type="primary" v-else disabled >{{showtime}}s</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="消费金额" prop="consumeMoney" label-width="80px">
                            <div class="flex-n fac">
                                <el-input placeholder="￥" class="w-220 mr-10" v-model="dataForm.consumeMoney"
                                          v-number="{precision:2}">
                                </el-input>
                                <div>元</div>
                            </div>
                        </el-form-item>
                        <el-form-item label="备 注" prop="remark" label-width="80px">
                            <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                                      maxlength="512"></el-input>
                        </el-form-item>
                        <el-form-item class="mt-10 flex-n fje">
                            <el-button type="primary" @click="handlePay('payForm')">确 定</el-button>
                            <el-button @click="showPay=false">取 消</el-button>
                        </el-form-item>
                    </el-form>
                </div>

            </el-dialog>
            <!--充值-->
            <el-dialog :visible.sync="showRecharge" v-if="showRecharge" class="doedit" width="760px" :close-on-click-modal="false">
                <div slot="title">
                    <z-title title="会员卡充值"></z-title>
                </div>
                <div class="rulefrom2">
                    <el-form :model="dataForm" :rules="rules" ref="rechargeForm" class=" mt-10">
                        <el-form-item label="会员卡号" :show-message="false" prop="memberNo" label-width="80px">
                            <el-input placeholder="请输入会员卡号" disabled class="w-220"
                                      v-model="dataForm.memberNo"></el-input>
                        </el-form-item>
                        <el-form-item label="会员姓名" :show-message="false" prop="memberName" label-width="80px">
                            <el-input placeholder="请输入会员姓名" disabled class="w-220"
                                      v-model="dataForm.memberName"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码"  prop="memberPhone" label-width="80px">
                            <el-input placeholder="请输入手机号码" disabled class="w-220"
                                      v-model="dataForm.memberPhone"></el-input>
                        </el-form-item>
                        <el-form-item label="充值金额" prop="rechargeMoney" label-width="80px">
                            <div class="flex-n fac">
                                <el-input placeholder="￥" class="w-220 mr-10" v-model="dataForm.rechargeMoney"
                                          v-number="{precision:2}">
                                </el-input>
                                <div>元</div>
                                <div class="ml-20">卡内余额： {{dataForm.cardBalance}}</div>
                            </div>
                        </el-form-item>
                        <el-form-item label-width="80px" style="margin-top: -20px!important;" label="">
                            <template v-if="dataForm.cardType=='01'">
                                <el-tag size="mini" type="success">{{dataForm.cardTypeName}}</el-tag>
                            </template>
                            <template v-if="dataForm.cardType=='02'">
                                <el-tag size="mini" type="success">{{dataForm.cardTypeName}}</el-tag>
                            </template>
                            {{dataForm.cardRule}}
                        </el-form-item>
                        <el-form-item label="备 注" prop="remark" label-width="80px">
                            <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                                      maxlength="512"></el-input>
                        </el-form-item>
                        <el-form-item class="mt-10 flex-n fje">
                            <el-button type="primary"  @click="handleRecharge('rechargeForm')">确 定</el-button>
                            <el-button @click="showRecharge=false">取 消</el-button>
                        </el-form-item>
                    </el-form>
                </div>

            </el-dialog>
        </template>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import WantHouse from "../../components/data/wantHouse";
    import MemberTypeList from "../../components/data/memberTypeList";
    import CardTypeCode from "../../components/data/cardTypeCode";
    import CardStateCode from "../../components/data/cardStateCode";
    import StoreList from "../../components/data/storeList";
    import AllStoreList from "../../components/allStoreList";
    import StoreDrop from "../../components/storeDrop";
    import ElTag from "element-ui/packages/tag/src/tag";
    import Pagination from "../../components/pagination/pagination";

    export default {
        components: {
            Pagination,
            ElTag,
            StoreDrop,
            AllStoreList,
            StoreList,
            CardStateCode,
            CardTypeCode,
            MemberTypeList,
            WantHouse,
            ZTitle
        },
        name: "info",
        data() {
            var validatetel = (rule, value, callback) => {
                console.log(value)
                if(value&&value.length!=11||!value){
                    return callback(new Error('请输入11位的有效手机号码'));
                }
                return callback();
            };
            return {
                loading: false,
                pageSize: 20,
                height:250,
                currentPage: 1,
                total: 0,
                dataForm: {
                    cardType: '',
                    totalCharge:0,
                    suitStores:[{storeName: '全部门店', storeId: 'all'}],
                    memberNo:'',
                    memberName:'',
                    memberPhone:'',
                    cardState: '',

                },
                editstate: '新增',
                showdialog: false,
                dataList: [{}],
                rules: {
                    memberNo: [{required: true, trigger: 'blur'}],
                    memberName: [{required: true, trigger: 'blur'}],
                    memberPhone: [{validator: validatetel, trigger: 'blur'},
                        {required: true,message: ' ', trigger: 'change'}],

                    memberCardId: [{required: true, trigger: 'change'}],
                    suitStores: [{required: true, trigger: 'change'}]
                },
                showPay: false,
                showRecharge: false,
                name: '',
                date: '',
                memberNo: '',
                memberName: '',
                memberPhone: '',
                cardState: '',
                storeId: '',
                showinfo: true,
                suitStores:[],
                cleartime:'',
                sendcodestate:0,//0,1是发送重新发送，2是倒计时开始
                showtime:60,
            }
        },
        watch: {
            showtime(newval,oldval){
                if(newval==0){
                    clearInterval(this.cleartime);
                    this.showtime=60;
                    this.sendcodestate=1;
                }
            },
            showdialog(newval, oldval) {
                if (!newval) {
                    this.$set(this.dataForm, 'suitStores', []);
                    this.$set(this.dataForm, 'cardType', '');
                    this.$refs.ruleForm.resetFields();
                }else{
                    if(this.editstate=='新增'){
                        this.dataForm={};
                    }
                }
            },
            showPay(newval, oldval) {
                if (!newval) {
                    this.$refs.payForm.resetFields();
                }
            },
            showRecharge(newval, oldval) {
                if (!newval) {
                    this.$refs.rechargeForm.resetFields();
                }
            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 200;
                console.log(this.height)
            },0)
            this.getMember();
        },
        methods: {
            sendCode(phone) {
                this.$axios.post('/sms/sendSms',{
                    "phone": phone,
                    "type":"SEND_CODE"
                }).then(res=>{
                    this.$message.success('验证码发送成功');
                    this.sendcodestate=2;
                    this.cleartime=setInterval(()=>{
                        this.showtime--;
                    },1000)
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            changeMemberlist(data) {
                console.log(data)
                this.$set(this.dataForm, 'cardDiscount', data.discount);
                this.$set(this.dataForm, 'totalCharge', data.rechargeMoney);
                this.$set(this.dataForm, 'cardBalance', data.receiveMoney);
                this.$set(this.dataForm, 'cardType', data.cardType);
            },
            getStores(data){
                console.log('适用店铺',data)
                // for(var i in data){
                //     if(data[i].storeId=='all'){
                //         data.splice(i,1);
                //         break;
                //     }
                // }
                this.suitStores=data;
            },
            //查询会员信息列表
            getMember() {
                this.loading = true;
                this.$axios.post('/member/memberList', {
                    "memberNo": this.memberNo,
                    "memberName": this.memberName,
                    "memberPhone": this.memberPhone,
                    "cardState": this.cardState,
                    "storeId": this.storeId||this.$root.getStorage('storeId'),
                    "pageNum": this.currentPage,
                    "pageSize": this.pageSize,
                }).then(res => {
                    console.log('会员信息列表', res);
                    var dataList = res.data.list;
                    for (var i = 0, len = dataList.length; i < len; i++) {
                        dataList[i].suitStoresContent = '';
                        for (var j = 0, len2 = dataList[i].suitStores.length; j < len2; j++) {
                            dataList[i].suitStoresContent += dataList[i].suitStores[j].storeName + '、';
                        }
                        if (dataList[i].suitStoresContent.length > 0) {
                            dataList[i].suitStoresContent = dataList[i].suitStoresContent.substring(0, dataList[i].suitStoresContent.length - 1);
                        }
                    }
                    this.dataList = dataList;
                    this.total = res.data.total;
                    this.loading = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                    this.loading = false;
                })
            },
            //搜索
            searchMember() {
                this.currentPage = 1;
                this.getMember();
            },
            //添加
            addMember() {
                this.showdialog = true;
                this.editstate = '新增';
            },
            handleClick(id, state) {
                console.log('编辑', id)
                this.id = id;
                this.$axios.get('/member/memberById/' + id).then(res => {
                    console.log(res)
                    this.dataForm = res.data;
                    this.$set(this.dataForm,'remark','');
                    if (state == 0) {
                        this.showPay = true;
                    }
                    if (state == 1) {
                        this.editstate = '编辑';
                        this.showdialog = true;
                        this.getStores(res.data.suitStores);
                        this.$refs.storelist.change(res.data.suitStores);
                    }
                    if (state == 2) {
                        this.showRecharge = true;
                    }
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            //添加提交
            addSubmit() {
                let data = this.dataForm;
                this.$axios.post('/member/memberAdd', {
                    "storeId":this.$root.getStorage('storeId'),
                    "memberNo": data.memberNo,
                    "memberName": data.memberName,
                    "memberPhone": data.memberPhone,
                    "memberCardId": data.memberCardId,
                    "totalCharge": data.totalCharge,
                    "totalConsume":0,
                    "suitStores":this.suitStores,
                    "cardState": '01',
                    "cardBalance": data.cardBalance,
                    "remark": data.remark
                }).then(res => {
                    this.currentPage = 1;
                    this.getMember();
                    this.$message.success('新增会员成功！');
                    this.showdialog = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            //编辑提交
            editSubmit() {
                let data = this.dataForm;
                this.$axios.post('/member/memberUpdate', {
                    "id": this.id,
                    "storeId": data.storeId,
                    "memberName": data.memberName,
                    "memberNo": data.memberNo,
                    "memberPhone": data.memberPhone,
                    "memberCardId": data.memberCardId,
                    "totalCharge": data.totalCharge,
                    "totalConsume": data.totalConsume,
                    "suitStores":this.suitStores,
                    "cardDiscount": data.cardDiscount,
                    "cardBalance": data.cardBalance,
                    "cardState": data.cardState,

                    "remark": data.remark
                }).then(res => {
                    this.$message.success('编辑会员成功！');
                    this.getMember();
                    this.showdialog = false;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            handlePay(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.validateCode(this.dataForm.memberPhone,this.dataForm.qrcode);

                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            validateCode(phone, code) {
                this.$axios.post('/sms/validCode',{
                    "phone": phone,
                    "code": code
                }).then(res=>{
                    this.submitPay();
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            submitPay(){
                let data = this.dataForm;
                this.$axios.post('/member/memberConsumeUpdate', {
                    "id":this.id,
                    "memberNo": data.memberNo,
                    "memberName": data.memberName,
                    "memberPhone": data.memberPhone,
                    "cardBalance": data.cardBalance,
                    "consumeMoney": data.consumeMoney,
                    "storeId": this.$root.getStorage('storeId'),
                    "remark": data.remark
                }).then(res => {
                    this.getMember();
                    this.$message.success('会员消费成功！');
                    this.showtime=0;
                    this.showPay= false;
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            handleRecharge(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let data = this.dataForm;
                        this.$axios.post('/member/memberRechargeUpdate', {
                            "id":this.id,
                            "memberNo": data.memberNo,
                            "memberName": data.memberName,
                            "memberPhone": data.memberPhone,
                            "rechargeMoney": data.rechargeMoney,
                            // "companyId": data.companyId,
                            "storeId": this.$root.getStorage('storeId'),
                            "remark": data.remark
                        }).then(res => {
                            this.getMember();
                            this.$message.success('会员充值成功！');
                            this.showRecharge = false;
                        }).catch(err => {
                            this.$message.error(err.msg);
                        })
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            //验证表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.editstate == '新增') {
                            this.addSubmit();
                        } else {
                            this.editSubmit();
                        }
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getMember();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getMember();
                console.log(`当前页: ${val}`);
            },
        },
        beforeDestroy(){
            clearInterval(this.cleartime);
        }
    }
</script>

<style scoped>

</style>